<template>
  <footer class="footer">
    <footer-subscribe-form v-if="$i18n.locale === 'ru'"></footer-subscribe-form>

    <footer-menu></footer-menu>
  </footer>
</template>

<script>
import FooterSubscribeForm from '~/components/footer/FooterSubscribeForm'
import FooterMenu from '~/components/footer/FooterMenu'

export default {
  name: 'AppFooter',
  components: {
    FooterSubscribeForm,
    FooterMenu
  }
}
</script>

<style lang="scss">
.footer {
  padding-bottom: 60px;
  background-color: $primary;
  color: #FFF;
}
</style>